import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { Reveal, Overline } from "@/components/Reveal";

export default function Readings() {
    const [items, setItems] = useState([]);
    useEffect(() => { api.get("/readings").then((r) => setItems(r.data)); }, []);

    return (
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16">
            <Reveal>
                <Overline>Divination &amp; Consultation</Overline>
                <h1 className="mt-3 font-serif text-5xl sm:text-6xl text-cream">Readings with Sherrie</h1>
                <p className="mt-4 text-ash max-w-2xl">Sit with Sherrie for honest spiritual guidance, tarot, bone &amp; curio divination, and ancestor messages.</p>
            </Reveal>

            <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {items.map((s, i) => (
                    <Reveal key={s.id} delay={(i % 3) * 0.08}>
                        <Link to={`/readings/${s.id}`} data-testid={`reading-${s.id}`} className="group block rounded-2xl overflow-hidden bg-surface border border-gold/10 hover:border-gold/40 transition-colors">
                            <div className="relative aspect-[4/3] overflow-hidden">
                                <img src={s.image} alt={s.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                                <div className="absolute inset-0 bg-gradient-to-t from-ink/70 to-transparent" />
                            </div>
                            <div className="p-6">
                                <div className="text-[10px] uppercase tracking-widest text-faded">{s.duration}</div>
                                <h3 className="mt-2 font-serif text-2xl text-cream group-hover:text-gold transition-colors">{s.name}</h3>
                                <p className="mt-2 text-sm text-ash line-clamp-2">{s.description}</p>
                                <div className="mt-4 flex items-center justify-between">
                                    <span className="text-gold text-lg">${s.price.toFixed(0)}</span>
                                    <ArrowRight className="w-4 h-4 text-gold group-hover:translate-x-1 transition-transform" />
                                </div>
                            </div>
                        </Link>
                    </Reveal>
                ))}
            </div>
        </div>
    );
}
